import { Box, useMultiStyleConfig, VStack } from '@chakra-ui/react';
import React from 'react';

import ImageHandler from '../../ImageHandler';
import { H3, Text } from '../../Text';

interface EmployeeCardProps {
  image: StaticImageDef | React.ReactElement;
  fullName?: string;
  jobTitle?: string;
  emailAddress?: string;
}

const EmployeeCard: React.FC<EmployeeCardProps> = ({
  image,
  fullName,
  jobTitle,
  emailAddress,
  children,
}) => {
  const styles = useMultiStyleConfig('EmployeeCard', {});
  return (
    <VStack sx={styles.container}>
      <Box sx={styles.image}>
        <ImageHandler image={image} />
      </Box>
      <Box sx={styles.content}>
        {fullName && <H3 sx={styles.name}>{fullName}</H3>}
        {jobTitle && <Text sx={styles.title}>{jobTitle}</Text>}
        {emailAddress && (
          <Text as="i" sx={styles.email}>
            {emailAddress}
          </Text>
        )}
        {children}
      </Box>
    </VStack>
  );
};

export default EmployeeCard;
